module.exports = __webpack_public_path__ + "img/m_banner01_holidayathome-c.57ee36d5.jpg";